import { useParams } from "react-router-dom";
import { useAthleteProfile } from "../../api/athleteprofile/queryHooks";
import { decodeId, get_media_url } from "../../api/utils";

const AthleteprofileDetail = ({ data }) => {
  return (
    <div className="h-[75px] w-full px-[15px] flex items-end">
      <div>
        <img
          alt="profileimage"
          src={get_media_url(data.profile_dp)}
          className="w-[75px] h-[75px] rounded-full border"
        />
      </div>
      <div className="ml-[15px] mb-2">
        <div className="text-base lg:text-xl">{data.full_name}</div>
        <div className="text-xs flex items-center justify-between">
          <p>{data.followers_count} Followers</p>
          <div className="h-[15px] border-l mx-4"></div>
          <p>{data.following_count} Followings</p>
        </div>
      </div>
    </div>
  );
};

const AthleteprofileCard = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading, isError } = useAthleteProfile(id);

  if (isError) return null;

  if (isLoading)
    return (
      <div>
        <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] relative w-full skeleton"></div>
      </div>
    );

  return (
    <>
      <div>
        <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] relative">
          <img
            className="w-full h-full object-cover"
            src={get_media_url(data.data.profile_cover)}
            alt="challenge"
          />
          <div
            className="absolute bottom-0 bg-black h-[83px] w-full bg-gradient-to-t"
            style={{
              background: "linear-gradient(to top, #00000099, #00000000)",
            }}
          ></div>
          <div className="absolute bottom-2 w-full flex justify-center">
            <AthleteprofileDetail data={data.data} />
          </div>
        </div>
      </div>
      <div className="mt-2">
        <p className="text-xs">{data.data.bio_description}</p>
      </div>
    </>
  );
};

export default AthleteprofileCard;
